import React, { useState } from 'react';
import { X } from 'lucide-react';
import { gallery } from '../data/mock';

export const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = [
    { id: 'all', label: 'Todas' },
    { id: 'fleet', label: 'Frota' },
    { id: 'unir', label: 'UNIR' },
    { id: 'tourism', label: 'Turismo' }
  ];


  const filteredGallery = selectedCategory === 'all' ?
  gallery :
  gallery.filter((item) => item.category.includes(selectedCategory));

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-[#003d82] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Galeria</h1>
            <p className="text-xl text-gray-200">Conheça a nossa frota moderna!

            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-gray-50 border-b">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) =>
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
              selectedCategory === category.id ?
              'bg-[#003d82] text-white shadow-lg scale-105' :
              'bg-white text-gray-700 hover:bg-gray-100'}`
              }>

                {category.label}
              </button>
            )}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredGallery.map((item) =>
            <div
              key={item.id}
              onClick={() => setSelectedImage(item)}
              className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-all duration-300">

                <img
                src={item.url}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-white font-semibold text-lg">{item.title}</h3>
                    <p className="text-gray-200 text-sm capitalize">{item.category}</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {filteredGallery.length === 0 &&
          <div className="text-center py-12">
              <p className="text-gray-500 text-lg">
                Nenhuma imagem encontrada nesta categoria.
              </p>
            </div>
          }
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage &&
      <div
        className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
        onClick={() => setSelectedImage(null)}>

          <button
          onClick={() => setSelectedImage(null)}
          className="absolute top-4 right-4 text-white hover:text-[#f5a623] transition-colors">

            <X size={32} />
          </button>
          <div className="max-w-6xl max-h-[90vh] relative">
            <img
            src={selectedImage.url}
            alt={selectedImage.title}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()} />

            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
              <h3 className="text-white font-semibold text-xl">{selectedImage.title}</h3>
              <p className="text-gray-200 capitalize">{selectedImage.category}</p>
            </div>
          </div>
        </div>
      }

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-[#003d82] mb-4">
              Interessado nos Nossos Serviços?
            </h2>
            <p className="text-xl text-gray-600 mb-8">Entre em contacto connosco e descubra como podemos ajudar!

            </p>
            <a
              href="/contacto"
              className="inline-block bg-[#f5a623] text-[#003d82] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#e5a71b] transition-all duration-300 hover:shadow-xl hover:scale-105">

              Contactar Agora
            </a>
          </div>
        </div>
      </section>
    </div>);

};